import { axios } from '../../utils/request'
import path from '../../api/path'

// 页面主数据接口
export function getListArray (params) {
  const url = '/' + path.apiName +  path.php + '/shipment-handing/cases'
  return axios({
    url: url,
    method: 'post',
    data: params
  })
}

// 页面的Status接口
export function getProcessStatus (caseType) {
  const url = '/' + path.apiName +  path.php + '/master-data/processStatus/' + caseType
  return axios({
    url: url,
    method: 'get'
  })
}

// 选择BG 和 BG对应的数据
export function getBgAndSelectionArray () {
  const url = '/' + path.apiName +  path.php + '/master-data/carrierCase'
  return axios({
    url: url,
    method: 'get'
  })
} /// shipment-handing/{uuid}

export function getViewDetail (uuid) {
  const url = '/' + path.apiName +  path.php + '/shipment-handing/' + uuid
  return axios({
    url: url,
    method: 'get'
  })
}


export function withdrawOrder (uuid) {
  const url = '/' + path.apiName +  path.php + '/shipment-handing/withdraw/' + uuid
  return axios({
    url: url,
    method: 'delete'
  })
}

